import React from 'react';
import AppRoleTable from './views/AppRoleTable';
import UserRoleTable from './views/UserRoleTable';
import {AppResourceTabs} from './views/AppResourceTable';
import RolePermissionTable from './views/RolePermissionTable';
import RoleTable from './views/RoleTable';
import UserAccessTable from './views/UserAccessTable';

export const ScreenMapping = [
  {
    id: 'roles',
    view: <RoleTable />,
  },
  {
    id: 'appRole',
    view: <AppRoleTable />,
  },
  {
    id: 'appResource',
    view: <AppResourceTabs />,
  },
  {
    id: 'resourcePermission',
    view: <RolePermissionTable />,
  },
  {
    id: 'userRole',
    view: <UserRoleTable />,
  },
  {
    id: 'userResource',
    view: <UserAccessTable />,
  },
];
